import { render } from "./BuyersGuideSearch.vue?vue&type=template&id=7b631ef2"
import script from "./BuyersGuideSearch.vue?vue&type=script&lang=js"
export * from "./BuyersGuideSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/BuyersGuide/BuyersGuideSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b631ef2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b631ef2', __exports__)) {
    api.reload('7b631ef2', __exports__)
  }
  
  module.hot.accept("./BuyersGuideSearch.vue?vue&type=template&id=7b631ef2", () => {
    api.rerender('7b631ef2', render)
  })

}


export default __exports__